import { createReducer } from '../../utils/misc'
import moment from 'moment'

import {
  AUTH_USER,
  UNAUTH_USER,
  AUTH_USER_ERROR,
  AUTH_USER_REQUEST
} from '../constants/auth'

const initialState = {
  isAuthenticated: false,
  authenticating: false,
  token: '',
  permissions: [],
  type: '',
  actionsInApplication: [],
  loginTimestamp: null
}

export default createReducer(initialState, {
  [AUTH_USER]: (state, payload) =>
    Object.assign({}, state, {
      isAuthenticated: true,
      token: payload.token,
      permissions: payload.permissions,
      loginTimestamp: moment(),
      actionsInApplication: payload.permissions && payload.permissions.reduce(
        (acc, p) => {
          return acc.concat(p.application.action)
        }, []
      ),
      type: payload.type,
      error: null,
      authenticating: false
    }),
  [AUTH_USER_REQUEST]: (state) =>
    Object.assign({}, state, {
      authenticating: true
    }),
  [AUTH_USER_ERROR]: (state, payload) =>
    Object.assign({}, state, {
      error: payload,
      authenticating: false
    }),
  [UNAUTH_USER]: (state) =>
    Object.assign({}, state, {
      isAuthenticated: false,
      token: '',
      error: null,
      loginTimestamp: null
    })
})
